// extracted by mini-css-extract-plugin
export var privacyPolicyTable = "PrivacyPolicyTable--privacyPolicyTable--M+-S+";
export var tkMyriadProSemiCondensed = "PrivacyPolicyTable--tk-myriad-pro-semi-condensed--Uol2W";